module.exports = __webpack_public_path__ + "static/media/0034.7f9d3ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors/Decors_black/0034.png
// module id = 843
// module chunks = 0